import React, { useState, useMemo } from 'react';
import { Link } from 'react-router-dom';
import '../styles/blogs.css';
import blogsData from '../data/blogs.json';

function BlogList() {
  const [currentPage, setCurrentPage] = useState(1);
  const PAGE_SIZE = 10; // posts per page

  // sort newest first
  const sortedBlogs = useMemo(() => {
    return [...(blogsData.blogs || [])].sort((a, b) => new Date(b.date) - new Date(a.date));
  }, []);

  const totalPages = Math.max(1, Math.ceil(sortedBlogs.length / PAGE_SIZE));

  const currentBlogs = useMemo(() => {
    const start = (currentPage - 1) * PAGE_SIZE;
    return sortedBlogs.slice(start, start + PAGE_SIZE);
  }, [currentPage, sortedBlogs]);

  const goToPage = (page) => {
    const p = Math.min(Math.max(1, page), totalPages);
    setCurrentPage(p);
    // scroll into view of the blogs list for better UX
    const el = document.querySelector('.blogs-list');
    if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  return (
    <div className="blogs-page">
      <section className="blogs-hero">
        <div className="container">
          <p>Insights on Architecture, System Design, and AI-Powered Development</p>
        </div>
      </section>

      <section className="blogs-grid">
        <div className="container">
          <div className="blogs-list">
            {currentBlogs.map((blog) => (
              <article key={blog.id} className="blog-card">
                <Link to={`/blog/${blog.id}`} className="blog-link">
                  <div className="blog-image">
                    <img
                      src={blog.featuredImage}
                      alt={blog.title}
                      style={{ width: '100%', height: 200, objectFit: 'cover' }}
                    />
                  </div>
                  <div className="blog-content">
                 
                    <h5 className="blog-title">{blog.title}</h5>
                    <p className="blog-excerpt">{blog.excerpt}</p>
                  
                    <div className="blog-tags">
                      {Array.isArray(blog.tags) && blog.tags.map((tag, index) => (
                        <span key={index} className="tag">#{tag}</span>
                      ))}
                    </div>
                  </div>
                </Link>
              </article>
            ))}

            {/* Pagination Controls */}
            <div className="pagination" style={{ display: 'flex', justifyContent: 'center', gap: '0.5rem', marginTop: '2rem' }}>
              <button onClick={() => goToPage(currentPage - 1)} disabled={currentPage === 1} aria-label="Previous page">Prev</button>
              {Array.from({ length: totalPages }, (_, i) => i + 1).map((p) => (
                <button
                  key={p}
                  onClick={() => goToPage(p)}
                  aria-current={p === currentPage ? 'page' : undefined}
                  style={{ fontWeight: p === currentPage ? '700' : '400' }}
                >
                  {p}
                </button>
              ))}
              <button onClick={() => goToPage(currentPage + 1)} disabled={currentPage === totalPages} aria-label="Next page">Next</button>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default BlogList;